module.exports = __webpack_public_path__ + "img/detail.1a782b8a.png";